export interface IFacet {
  facet: string;
  options: {
    count: number;
    label: string;
    value: string;
  }[];
}

export interface IMatchingSearchState {
  loading: boolean;
  error: string | null;
  results: any[];
  facets: {
    founding_date: IFacet;
    sectors: IFacet;
    countries: IFacet;
    regions: IFacet;
  };
  hit_count: number;
  page: number;
  per_page: number;
  filters: {
    vil: number[];
    countries: string[];
    sectors: string[];
    query: string;
    founding_date: number[];
    action: "search" | "scroll";
  };
}

export enum EMatchingSearchState {
  NAMESPACE = "matchingSearch",
}

export enum EMatchingSearchActions {
  SEARCH = "matchingSearch/search",
  LOAD_FACETS = "matchingSearch/loadFacets",
  SET_FILTERS = "matchingSearch/setFilters",
}

export enum EMatchingSearchMutations {
  SET_LOADING = "setLoading",
  SET_ERROR = "setError",
  SET_RESULTS = "setResults",
  SET_FACETS = "setFacets",
  SET_FILTERS = "setFilters",
}

export enum EMatchingSearchGetters {
  RESULTS = "matchingSearch/results",
  FACETS = "matchingSearch/facets",
}
